import { render, staticRenderFns } from "./HerstellerImportierenComponent.vue?vue&type=template&id=6934dc72&"
import script from "./HerstellerImportierenComponent.vue?vue&type=script&lang=js&"
export * from "./HerstellerImportierenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports